import { ModelBase } from '../../core/model/model-base';
import { PriceListItem } from './pricelistitem';

export enum PriceListType {
  ExternalInvoicing = 1,
  InternalReporting = 2,
}

export class PriceList extends ModelBase {
  constructor(dataContext?: any) {
    super();
    if (dataContext) {
      this.name = dataContext.name;
      this.id = dataContext.id;
      this.currencyCode = dataContext.currencyCode;
      this.priceListItems = Array.isArray(dataContext.priceListItems)
        ? dataContext.priceListItems.map(x => {
            let i = new PriceListItem(x);
            i.id = x.id;
            return i;
          })
        : [];
      this.listType = dataContext.listType;
    } else {
      this.listType = PriceListType.ExternalInvoicing;
    }
  }

  name: string;
  currencyCode: string;
  priceListItems: PriceListItem[] = [];
  listType: PriceListType;

  get typeCaption(): string {
    return this.listType == PriceListType.InternalReporting ? 'PRICELIST.PRICELIST_TYPE_REPORTING' : 'PRICELIST.PRICELIST_TYPE_INVOICING';
  }

  toString(): string {
    return this.name;
  }

  toJSON() {
    return this;
  }
}
